import React from "react";
import HistoricalSavingsBadge from "./HistoricalSavingsBadge";

const SpeciesListingHero = ({
  title,
  scientificName,
  priceRange,
  availableSizes,
  subtitle = scientificName,
  primaryMeta = priceRange,
  secondaryMeta = availableSizes,
  historicalSavingsPercent = null,
  imageContent,
  headerActions,
  expanded = false,
  onClick,
  cardRef = null,
  id,
  className = "",
  openLabel = `View all listings for ${title}`,
  closeLabel = `Collapse ${title}`,
}) => (
  <article
    ref={cardRef}
    id={id}
    className={`species-listing-hero fish-item relative rounded-lg bg-slate-800 shadow-md ${
      expanded ? "species-listing-hero-expanded" : "species-listing-hero-collapsed"
    } ${className}`.trim()}
  >
    <div className="species-listing-hero-image absolute inset-0">
      {imageContent}
    </div>

    <button
      type="button"
      className="species-listing-hero-button absolute inset-0 z-10 cursor-pointer rounded-lg"
      onClick={onClick}
      aria-expanded={expanded}
      aria-label={expanded ? closeLabel : openLabel}
    />

    <div className="species-listing-hero-actions absolute right-2 top-2 z-30">
      {headerActions}
    </div>

    <div className="species-listing-hero-overlay pointer-events-none absolute inset-0 z-20 flex flex-col justify-end p-3 text-white">
      <h2 className="species-listing-hero-title font-semibold leading-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="species-listing-hero-scientific mt-0.5 italic leading-tight">
          {subtitle}
        </p>
      )}
      <div className="species-listing-hero-summary mt-2 flex items-end justify-between gap-2">
        <div className="species-listing-hero-price flex items-center gap-2 font-semibold">
          <span>{primaryMeta}</span>
          <HistoricalSavingsBadge percent={historicalSavingsPercent} />
        </div>
        <div className="species-listing-hero-sizes text-right">
          {secondaryMeta}
        </div>
      </div>
    </div>
  </article>
);

export default SpeciesListingHero;
